import CollectionService from '@boServices/collectionService';
import TagService from '@boServices/tagService';
import { useEffect, useState } from 'react';

const collectionService = new CollectionService();
const tagService = new TagService();

const languageToOption = (l) => ({ value: l.id, label: l.nom });

const useCollectionOptions = () => {
    const [tagsOptions, setTagsOptions] = useState([]);
    const [languagesOptions, setLanguagesOptions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        Promise.all([tagService.getTags(), collectionService.getLangues()])
            .then(([tagsData, languagesData]) => {
                setTagsOptions({
                    typology: tagsData.filter((tag) => tag.type === 'typology'),
                    domain: tagsData.filter((tag) => tag.type === 'domain'),
                    family: tagsData.filter((tag) => tag.type === 'family'),
                });
                setLanguagesOptions((Array.isArray(languagesData) ? languagesData : []).map(languageToOption));
            })
            .catch(setError)
            .finally(() => setLoading(false));
    }, []);

    return { tagsOptions, languagesOptions, loading, error };
};

export default useCollectionOptions;
